import React, { useEffect, useState } from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input';
import arrowDown from '../../../assets/svg/arrow-down.svg';
import axiosClient from '../../../../axios-client';
import icPhone from '../../../assets/svg/ic-hone-div.svg';
import { getCountries } from 'react-phone-number-input/input';
import { useOutletContext } from 'react-router-dom';

const WhatsAppAreaCode = ({ selectedTemplateId, langId, getCountryId, getFlowId, dataToSend, isForm }) => {
  const [templateSelected, setTemplateSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedCountryId, setSelectedCountryID] = useState();
  const [selectedCountryFlag, setSelectedCountryFlag] = useState();
  const [phone, setPhone] = useState();
  const [isSuccess, setSuccess] = useState(false);
  const [isSending, setSending] = useState(false);
  const [flowId, setFlowId] = useState();
  const { credits, setCredits } = useOutletContext();
  const [msgTest, setMsgTest] = useState('');

  useEffect(() => {
    getByTemplateId();
  }, [selectedTemplateId]); // Adding selectedTemplateId to dependency array

  const userInfo = () => {
    setLoading(true);
    axiosClient.get('/credits')
      .then(({ data }) => {
        setLoading(false);
        setCredits(data.data.credit);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const supportedCountries = getCountries().filter((code) => code !== 'EH');

  const getByTemplateId = async () => {
    if (selectedTemplateId) {
      setLoading(true);
      try {
        const response = await axiosClient.get(`/template/accounts?template_id=${selectedTemplateId}`);
        const data = response.data.data;

        setLoading(false);
        setTemplateSelected(data);
        if (data.length > 0) {
          setSelectedCountryFlag(data[data.length - 1].country.flag);
          setSelectedCountry(data[data.length - 1].phone);
          setSelectedCountryID(data[data.length - 1].country.id);
          setFlowId(data[data.length - 1].template_account_flow_id);
          if (getCountryId) {
            getCountryId(data[data.length - 1].country.id);
          }
          if (getFlowId) {
            getFlowId(data[data.length - 1].template_account_flow_id);
          }
        }
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }
  };

  const handleCountrySelect = (countryName, countryFlag, countryId, sflowId) => {
    setSelectedCountry(countryName);
    setSelectedCountryFlag(countryFlag);
    setSelectedCountryID(countryId);
    setFlowId(sflowId);
    if (getCountryId) {
      getCountryId(countryId);
    }
    if (getFlowId) {
      getFlowId(sflowId);
    }
  };

  const handleSendTest = () => {
    if (phone) {
      setSending(true);
      const payload = {
        language_id: langId,
        name: `Test => ${phone}`,
        country_id: selectedCountryId,
        template_id: selectedTemplateId,
        phone: phone,
        data: dataToSend,
        template_account_flow_id: flowId,
        ...(isForm ? { as_form: 'on' } : {}),
        ...(dataToSend?.labo_resultsfile ? { labo_resultsfile: dataToSend.labo_resultsfile } : {}),
        'is_test': true,
      };
      // console.log(payload)
      // return
      axiosClient.post('/messages?', payload)
        .then(({ data }) => {
          setLoading(false);
          setMsgTest(data.message);
          console.log(data.data)
          if (data.data.success) { 
            setSuccess(data.data.success);
            console.log(data.data)
          }
          setSending(false);
          userInfo();
        })
        .catch(err => {
          const response = err.response;
          if (response && response.status === 422) {
            setMsgTest(response.data.errors);
            setSuccess(false);
          } else if (response && response.status === 404) {
            setMsgTest(response.data.message);
          }
          setLoading(false);
        });
    }
  };

  return (
    <div className="container">
      <div className={`col-md-12 p-0`}>
        <div className="row justify-content-start align-items-center px-5 mt-5 pb-5">
          <h3 className="py-2">Choose WhatsApp area code</h3>
          <div className="col-md-7">
            <div className="bg-gradient whatsapp-input d-flex form-control rounded-pill justify-content-start align-items-center">
              <img width="18" className="arrow-phone" src={arrowDown} />
              <DropdownButton
                className="bg-transparent border-0"
                title={<img className="p-1" width={35} src={selectedCountryFlag} alt="" />}
                id="dropdown-basic-button"
                variant=""
              >
                {templateSelected.map((item, index) => (
                  <Dropdown.Item
                    key={index}
                    onClick={() => handleCountrySelect(item.phone, item.country.flag, item.country.id, item.template_account_flow_id)}
                  >
                    <img className="p-1" width={30} src={item.country.flag} alt="" />
                    <span>{item.phone}</span>
                  </Dropdown.Item>
                ))}
              </DropdownButton>
              <div>{selectedCountry}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-100">
        <div className="divider mt-5"></div>

        <div className="row justify-content-center align-items-center mb-5">
          <img className="me-auto ms-auto ic-phone-divider p-0" src={icPhone} />
        </div>
        <h1 className="text-center title my-3">Test Number</h1>
        <div className="divider mt-5"></div>

        <div className="row justify-content-start align-items-center col-md-10 px-5 mt-5 mb-5">
          <h3 className="py-2">Test number</h3>
          <p className="pb-2">Congratulations. You are ready to send your first test. Put your number to receive it.</p>
          <div className="col-md-8">
            <div className="bg-transparent d-flex w-100 form-control rounded-pill justify-content-start align-items-center">
              <img width={18} className="arrow-phone" src={arrowDown} />
              <PhoneInput
                id="phoneId"
                className="form-control border-0 bg-transparent rounded-pill"
                placeholder="+212 669 47 00 00"
                international
                defaultCountry="MA"
                countries={supportedCountries}
                value={phone}
                onChange={(value) => setPhone(value)}
                countrySelectProps={{
                  unicodeFlags: true,
                }}
                countryCallingCodeEditable={true}
              />
              <span role="button" className="rounded-pill btn-send-whatsapp p-2 text-center" onClick={!isSending ? handleSendTest : () => { }}>
                {!isSending ? <>Send Test</> : <>Sending...</>}
              </span>
            </div>
            {msgTest && <div className="text-success mt-2">{msgTest}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppAreaCode;
